import { render, staticRenderFns } from "./StudyResultResolveTable.vue?vue&type=template&id=ed914794&scoped=true&lang=pug"
import script from "./StudyResultResolveTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultResolveTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultResolveTable.vue?vue&type=style&index=0&id=ed914794&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed914794",
  null
  
)

export default component.exports